import type { DefaultPaginatedFilters } from "./filters.types";

export * from "./filters.types";

export function filtersToQueryString(
  filters: Partial<DefaultPaginatedFilters>,
  fieldMap?: Record<string, string>
): string {
  // TODO remove paginate when all endpoints in BE remove this parameter.
  const urlParams = new URLSearchParams({ paginate: "true" });

  Object.entries(filters).forEach(([key, value]) => {
    if (value == null) {
      return;
    }
    if (key === "sortBy") {
      return;
    }
    if (typeof value === "string") {
      if (value.trim() !== "") {
        urlParams.append(key, value);
      }
    } else if (typeof value === "boolean") {
      urlParams.append(key, value ? "true" : "false");
    } else if (typeof value === "number") {
      urlParams.append(key, value.toString());
    } else if (Array.isArray(value) && value.length > 0) {
      urlParams.append(key, value.join(","));
    }
  });
  if (filters.search && !urlParams.has("search")) urlParams.append("search", filters.search);

  const ordering = filters?.sortBy
    ?.map(({ key, order }) => {
      const apiField = fieldMap?.[key] ?? key;
      return (order === "desc" ? "-" : "") + apiField;
    })
    .join(",");
  if (ordering) {
    urlParams.append("ordering", ordering);
  }

  if (urlParams.has("enabled")) {
    urlParams.delete("enabled");
  }

  return urlParams.toString();
}
